import {ApiClient} from '@hconnect/apiclient'
import {useQuery} from '@tanstack/react-query'

import {getOptimizedScheduleStatsPath} from '../api'
import type {OptimizedSchedulesStats} from '../api'

const ONE_MINUTE_REFRESH_INTERVAL = 60_000

export const OPTIMIZED_SCHEDULES_STATS_QUERY_KEY = 'optimizedSchedulesStats'

interface UseOptimizedSchedulesStatsParams {
  plantId: string
  throwOnError?: boolean
}

export const useOptimizedSchedulesStatsQuery = ({
  plantId,
  throwOnError = true
}: UseOptimizedSchedulesStatsParams) =>
  useQuery<OptimizedSchedulesStats>({
    queryKey: [OPTIMIZED_SCHEDULES_STATS_QUERY_KEY, {plantCode: plantId}],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<OptimizedSchedulesStats>(
        getOptimizedScheduleStatsPath(plantId),
        {signal}
      )
      return response.data
    },
    throwOnError,
    refetchInterval: ONE_MINUTE_REFRESH_INTERVAL
  })
